import { render, staticRenderFns } from "./betLimitSettings.vue?vue&type=template&id=41cf725e&lang=pug&"
import script from "./betLimitSettings.vue?vue&type=script&lang=js&"
export * from "./betLimitSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports